import * as t from "io-ts";
import { MaybeExportedTreeV } from "./tree";
import { TemplatePreviewableItemV } from "@/types/templates";

export const GlobalBlockSettingsV = t.type({
  preview: t.partial({
    width: t.number,
    height: t.number,
    backgroundColor: t.union([t.string, t.null]),
    isCentered: t.boolean,
    acfFlexibleField: t.string,
    acfFlexibleFieldRow: t.number
  })
});

export const GlobalBlockV = t.intersection([
  t.type({
    label: t.string,
    id: t.number, // can be -1 when creating a new post
    tree: MaybeExportedTreeV,
    editInBreakdanceLink: t.string
  }),
  t.partial({
    settings: t.union([GlobalBlockSettingsV, t.literal(false)]),
    status: t.union([t.literal("publish"), t.literal("trash")]),
    lastPreviewedItem: t.union([TemplatePreviewableItemV, t.literal(false)])
  })
]);

export type GlobalBlock = t.TypeOf<typeof GlobalBlockV>;

export const GlobalBlocksV = t.array(GlobalBlockV);
